import { X, ChevronRight } from "lucide-react";

export const Modal = ({ title, onClose, children, wide = false }) => (
  <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && onClose?.()}>
    <section
      className={wide ? "modal modal-wide" : "modal"}
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-head">
        <h2>{title}</h2>
        <button data-testid="modal-close-button" className="icon-button" onClick={onClose} aria-label="Close">
          <X size={19} />
        </button>
      </div>
      {children}
    </section>
  </div>
);

export const Field = ({ name, label, value, onChange, type = "text", required, placeholder, autoComplete, readOnly }) => (
  <label>
    {label}
    <input
      data-testid={`lead-form-${name}-input`}
      name={name}
      value={value ?? ""}
      onChange={onChange}
      type={type}
      required={required}
      placeholder={placeholder}
      autoComplete={autoComplete}
      readOnly={readOnly}
      style={readOnly ? { background: "#f1f5f9", cursor: "not-allowed" } : undefined}
    />
  </label>
);

export const PanelHead = ({ title, subtitle, action, onClick }) => (
  <div className="panel-head">
    <div>
      <h3>{title}</h3>
      {subtitle && <p className="muted small">{subtitle}</p>}
    </div>
    {action ? (
      <button
        onClick={onClick}
        data-testid={`panel-${title.toLowerCase().replaceAll(" ", "-")}-action`}
      >
        {action} <ChevronRight size={14} />
      </button>
    ) : null}
  </div>
);

export const Fact = ({ label, value, sensitive }) => (
  <div className="fact">
    <span>{label}</span>
    <strong className={sensitive ? "sensitive" : ""}>{value}</strong>
  </div>
);

export const Status = ({ value }) => (
  <span
    data-testid={`status-${value?.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-")}`}
    className={`status ${value?.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-")}`}
  >
    {value}
  </span>
);

export const Empty = ({ children }) => <div className="empty">{children}</div>;
export const Loading = ({ children }) => <div className="loading">{children}</div>;
